// extracted by mini-css-extract-plugin
module.exports = {"root":"_39qk9","iconsRow":"aUZ94","icon":"_2dyT7","old":"UMHs5","iconLabel":"gttNc"};